import React from "react";
import { Outlet } from "react-router";
import { PageShell } from "@sscs/ui";
import Navigation from "../../components/Navigation/Navigation";
import styles from "./insights.module.scss";

const Insights = (): React.JSX.Element => {
  return (
    <PageShell sidebar={<Navigation />} contentClassName={styles.content}>
      <Outlet />
    </PageShell>
  );
};

export default Insights;
